export default {
  layouts: {
    toogle_button: 'Toggle navigation',
    nav_bar_options: {
      account: 'Mi Cuenta',
      organization: 'Mi Organización',
      manageUsers: 'Mis Usuarios',
      logout: 'Salir',
    },
    welcome_alert: {
      p1: 'CAT4MRO es ahora ACCUSELLER, Bienvenido ',
      p2: ' de la empresa',
    },
    footer: 'Unilink Solutions',
    portals: 'Portales',
  },
};



// WEBPACK FOOTER //
// ./src/i18n/es-cl/layouts.js